// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__2_kVD","card_content":"styles_card_content__3I6-B"};